/**
 * Image Gallery Slider JavaScript
 */
(function($) {
    'use strict';

    class ImageGallerySlider {
        constructor() {
            this.containers = $('.image-gallery-slider-container');
            this.currentSlideIndex = 0;
            this.sliderItems = [];
            this.isTransitioning = false;
            this.toShow = 3;
            this.totalItems = 0;

            // Popup functionality reused from main gallery - check if popup exists
            this.popup = $('.gallery-popup');
            this.isPopupOpen = false;
            this.galleryData = new Map();
            this.preloadedImages = new Map();
            this.currentIndex = 0;
            this.currentImageIndex = 0;

            // If no popup exists, create one (same as main gallery)
            if (this.popup.length === 0) {
                this.createPopup();
            }

            this.init();
            this.bindPopupEvents();
        }

        bindPopupEvents() {
            // Bind popup events once globally
            this.popup.on('click', '.popup-close, .popup-overlay', (e) => {
                e.preventDefault();
                this.closePopup();
            });

            this.popup.on('click', '.popup-post-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.currentContainer) {
                    this.navigatePopup(-1, this.currentContainer);
                }
            });

            this.popup.on('click', '.popup-post-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.currentContainer) {
                    this.navigatePopup(1, this.currentContainer);
                }
            });

            this.popup.on('click', '.popup-image-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigateImage(-1);
            });

            this.popup.on('click', '.popup-image-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigateImage(1);
            });

            // Main popup navigation arrows (navigate between posts)
            this.popup.on('click', '.popup-nav-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.currentContainer) {
                    this.navigatePopup(-1, this.currentContainer);
                }
            });

            this.popup.on('click', '.popup-nav-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.currentContainer) {
                    this.navigatePopup(1, this.currentContainer);
                }
            });
        }

        createPopup() {
            const popupHTML = `
                <div class="gallery-popup" style="display: none;">
                    <div class="popup-overlay"></div>
                    <div class="popup-content">
                        <button class="popup-close"><i class="fas fa-times"></i></button>

                        <!-- General Navigation Buttons -->
                        <button class="popup-nav popup-nav-prev" disabled>
                            <i class="fas fa-chevron-left"></i>
                        </button>
                        <button class="popup-nav popup-nav-next" disabled>
                            <i class="fas fa-chevron-right"></i>
                        </button>

                        <div class="popup-main">
                            <div class="popup-image-container">
                                <img class="popup-image" src="" alt="" />
                                <div class="popup-image-counter">
                                    <span class="current-image">1</span> / <span class="total-images">1</span>
                                </div>
                                <div class="popup-image-nav">
                                    <button class="popup-image-prev" disabled><i class="fas fa-chevron-left"></i></button>
                                    <button class="popup-image-next" disabled><i class="fas fa-chevron-right"></i></button>
                                </div>
                            </div>
                            <div class="popup-details">
                                <h3 class="popup-title"></h3>
                                <div class="popup-content-text"></div>
                                <div class="popup-author"></div>
                                <div class="popup-actions">
                                    <!-- CTA buttons can be added here -->
                                </div>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="popup-post-navigation">
                                <button class="popup-post-prev" disabled>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                                    </svg>
                                    <span>Previous</span>
                                </button>
                                <button class="popup-post-next" disabled>
                                    <span>Next</span>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            $('body').append(popupHTML);
            this.popup = $('.gallery-popup');
        }

        init() {
            if (this.containers.length === 0) return;

            this.containers.each((index, container) => {
                this.initSlider($(container));
            });
        }

        initSlider($container) {
            const $slider = $container.find('.gallery-slider');
            const $wrapper = $container.find('.gallery-slider-wrapper');
            const $items = $slider.find('.slider-item');

            // Set toShow first
            this.toShow = parseInt($container.data('toshow')) || 3;

            if ($items.length === 0) {
                $container.find('.slider-navigation').hide();
                return;
            }

            this.sliderItems = $items.toArray();
            this.totalItems = this.sliderItems.length;

            // Initialize Slick Slider with proper configuration
            const slickConfig = {
                slidesToShow: this.toShow,
                slidesToScroll: 1,
                infinite: this.totalItems > this.toShow,
                arrows: false, // We'll use custom arrows
                dots: false,
                centerMode: false,
                variableWidth: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: Math.min(this.toShow, 2),
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            };

            // Set data attribute for CSS targeting
            $slider.attr('data-slides-to-show', this.toShow);

            // Initialize Slick
            $slider.slick(slickConfig);

            // Store reference to slick instance
            $container.data('slick-instance', $slider);

            // Bind events for this slider
            this.bindSliderEvents($container);

            // Show/hide navigation based on item count
            if (this.totalItems <= this.toShow) {
                $container.find('.slider-navigation').hide();
            } else {
                $container.find('.slider-navigation').show();
            }

            // Preload gallery data for popup functionality
            this.preloadSliderData($container);
        }


        bindSliderEvents($container) {
            const $slider = $container.find('.gallery-slider');

            // Navigation buttons with Slick
            $container.on('click', '.slider-prev', (e) => {
                e.preventDefault();
                $slider.slick('slickPrev');
            });

            $container.on('click', '.slider-next', (e) => {
                e.preventDefault();
                $slider.slick('slickNext');
            });

            // Item clicks for popup - ensure event delegation works
            $container.on('click', '.slider-item', (e) => {
                // Don't open popup if user was dragging (for mouse events)
                if ($slider.hasClass('dragging')) {
                    return;
                }
                
                e.preventDefault();
                e.stopPropagation();
                this.openPopup($(e.currentTarget), $container);
            });

            // Keyboard navigation
            $(document).on('keydown', (e) => {
                if (!this.isPopupOpen) return;

                switch(e.key) {
                    case 'Escape':
                        this.closePopup();
                        break;
                    case 'ArrowLeft':
                        this.navigatePopup(-1, $container);
                        break;
                    case 'ArrowRight':
                        this.navigatePopup(1, $container);
                        break;
                }
            });

            // Touch/swipe support for mobile
            this.addTouchSupport($container);
        }

        addTouchSupport($container) {
            const $slider = $container.find('.gallery-slider');
            let startX = 0;
            let currentX = 0;
            let isDragging = false;
            let hasMoved = false;
            let touchStartTime = 0;

            // Use different event targets to avoid conflicts
            $slider.on('touchstart', '.slider-item', (e) => {
                if (this.isTransitioning) return;

                isDragging = true;
                hasMoved = false;
                touchStartTime = Date.now();
                startX = e.originalEvent.touches[0].clientX;
                currentX = startX;
            });

            $(document).on('touchmove', (e) => {
                if (!isDragging || this.isTransitioning) return;

                currentX = e.originalEvent.touches[0].clientX;
                const diffX = currentX - startX;

                // Mark as moved if threshold exceeded
                if (Math.abs(diffX) > 15) {
                    hasMoved = true;
                    e.preventDefault(); // Prevent scrolling during swipe
                }
            });

            $(document).on('touchend', (e) => {
                if (!isDragging) return;

                isDragging = false;
                
                const diffX = currentX - startX;
                const threshold = 50;
                const touchDuration = Date.now() - touchStartTime;

                // Only trigger navigation if it was a significant swipe
                if (hasMoved && Math.abs(diffX) > threshold && touchDuration > 100) {
                    e.preventDefault(); // Prevent click event from firing
                    const $slider = $container.find('.gallery-slider');
                    if (diffX > 0) {
                        $slider.slick('slickPrev');
                    } else {
                        $slider.slick('slickNext');
                    }
                }
                // If no significant movement, let the click event handle it
            });

            // Mouse support for desktop
            $slider.on('mousedown', (e) => {
                if (this.isTransitioning) return;
                
                isDragging = true;
                hasMoved = false;
                startX = e.clientX;
                currentX = startX;
                $slider.addClass('dragging');
                e.preventDefault();
            });

            $(document).on('mousemove', (e) => {
                if (!isDragging || this.isTransitioning) return;

                currentX = e.clientX;
                const diffX = currentX - startX;

                if (Math.abs(diffX) > 10) {
                    hasMoved = true;
                }

                if (Math.abs(diffX) > 20) {
                    e.preventDefault();
                }
            });

            $(document).on('mouseup', (e) => {
                if (!isDragging) return;

                isDragging = false;
                $slider.removeClass('dragging');
                
                const diffX = currentX - startX;
                const threshold = 50;

                if (hasMoved && Math.abs(diffX) > threshold) {
                    const $slider = $container.find('.gallery-slider');
                    if (diffX > 0) {
                        $slider.slick('slickPrev');
                    } else {
                        $slider.slick('slickNext');
                    }
                }
            });
        }



        preloadSliderData($container) {
            const $items = $container.find('.slider-item');
            const postIds = $items.map((index, item) => $(item).data('id')).get();

            postIds.forEach(postId => {
                if (!this.galleryData.has(postId)) {
                    this.getPostData(postId).then(response => {
                        if (response.success) {
                            this.galleryData.set(postId, response.data);
                            this.preloadImages(postId, response.data);
                        }
                    }).catch(error => {
                        // Silently handle preload errors
                    });
                }
            });
        }

        preloadImages(postId, data) {
            const images = [];

            // Add featured image
            if (data.featured_image) {
                images.push(data.featured_image);
            }

            // Add gallery images
            if (data.gallery_images && Array.isArray(data.gallery_images)) {
                data.gallery_images.forEach(image => {
                    let imageUrl = '';
                    if (typeof image === 'string') {
                        imageUrl = image;
                    } else if (image && image.url) {
                        imageUrl = image.url;
                    } else if (image && image.sizes && image.sizes.large) {
                        imageUrl = image.sizes.large;
                    }
                    if (imageUrl) {
                        images.push(imageUrl);
                    }
                });
            }

            // Preload images
            images.forEach(imageUrl => {
                if (!this.preloadedImages.has(imageUrl)) {
                    const img = new Image();
                    img.onload = () => {
                        this.preloadedImages.set(imageUrl, true);
                    };
                    img.src = imageUrl;
                }
            });
        }

        openPopup(item, $container) {
            // Ensure item is a jQuery object
            const $item = $(item);

            // With Slick, items are wrapped in additional divs, so we need to find all slider items
            const $allItems = $container.find('.slider-item');

            // Find the index of the clicked item among all slider items
            let originalIndex = $allItems.index($item);

            if (originalIndex === -1) {
                // If the direct item wasn't found, it might be wrapped by Slick
                // Try to find the closest .slider-item parent
                const $closestItem = $item.closest('.slider-item');
                if ($closestItem.length > 0) {
                    originalIndex = $allItems.index($closestItem);
                }
            }

            if (originalIndex === -1) {
                return;
            }

            this.currentIndex = originalIndex;
            this.currentImageIndex = 0;
            this.isPopupOpen = true;
            this.currentContainer = $container;
            this.originalItems = $allItems.toArray();

            this.updatePopupContentFast();
            this.popup.show();
            $('body').addClass('popup-open');
        }

        closePopup() {
            this.isPopupOpen = false;
            this.popup.hide();
            $('body').removeClass('popup-open');
        }

        navigatePopup(direction, $container) {
            const totalOriginalItems = this.originalItems ? this.originalItems.length : 0;
            let newIndex = this.currentIndex + direction;

            // Enable infinite popup navigation like main gallery
            if (newIndex < 0) {
                newIndex = totalOriginalItems - 1;
            } else if (newIndex >= totalOriginalItems) {
                newIndex = 0;
            }

            this.currentIndex = newIndex;
            this.currentImageIndex = 0;
            this.updatePopupContentFast();
        }

        navigateImage(direction) {
            if (!this.originalItems || this.currentIndex >= this.originalItems.length) return;

            const currentItem = $(this.originalItems[this.currentIndex]);
            const hasMultipleImages = currentItem.find('.multiple-images-indicator').length > 0;

            if (!hasMultipleImages) return;

            const postId = currentItem.data('id');
            const data = this.galleryData.get(postId);

            if (data && data.gallery_images) {
                const images = data.gallery_images;
                const newIndex = this.currentImageIndex + direction;

                if (newIndex >= 0 && newIndex < images.length) {
                    this.currentImageIndex = newIndex;
                    this.updateImageInPopup(images[newIndex]);
                    this.updateImageNavigation(images.length);
                }
            }
        }

        updateImageInPopup(imageData) {
            const popup = this.popup;
            let imageUrl = '';

            if (typeof imageData === 'string') {
                imageUrl = imageData;
            } else if (imageData && imageData.url) {
                imageUrl = imageData.url;
            } else if (imageData && imageData.sizes && imageData.sizes.large) {
                imageUrl = imageData.sizes.large;
            }

            if (imageUrl) {
                popup.find('.popup-image').attr('src', imageUrl);
            }
        }

        updateImageNavigation(totalImages) {
            const popup = this.popup;
            const prevBtn = popup.find('.popup-image-prev');
            const nextBtn = popup.find('.popup-image-next');

            // Show/hide navigation based on current position
            if (this.currentImageIndex === 0) {
                prevBtn.hide();
            } else {
                prevBtn.show().prop('disabled', false);
            }

            if (this.currentImageIndex === totalImages - 1) {
                nextBtn.hide();
            } else {
                nextBtn.show().prop('disabled', false);
            }

            popup.find('.current-image').text(this.currentImageIndex + 1);
            popup.find('.total-images').text(totalImages);
        }

        updatePopupContentFast() {
            if (!this.originalItems || this.currentIndex >= this.originalItems.length) return;

            const currentItem = $(this.originalItems[this.currentIndex]);
            const postId = currentItem.data('id');
            const data = this.galleryData.get(postId);

            if (data) {
                // Use cached data for instant loading
                this.populatePopup(data);
            } else {
                // Fallback to AJAX if data not cached yet
                this.updatePopupContent(postId);
            }
        }

        updatePopupContent(postId) {
            // Show loading state
            this.showLoadingState();

            // Get post data via AJAX
            this.getPostData(postId)
                .then(response => {
                    if (response.success) {
                        this.galleryData.set(postId, response.data);
                        this.populatePopup(response.data);
                    } else {
                        this.showErrorState();
                    }
                })
                .catch(error => {
                    this.showErrorState();
                });
        }

        showLoadingState() {
            const popup = this.popup;
            popup.find('.popup-image').attr('src', '');
            popup.find('.popup-title').text('Loading...');
            popup.find('.popup-content-text').html('');
            popup.find('.popup-author').text('');
            popup.find('.popup-actions').empty();
        }

        showErrorState() {
            const popup = this.popup;
            popup.find('.popup-image').attr('src', '');
            popup.find('.popup-title').text('Error loading content');
            popup.find('.popup-content-text').html('<p>Sorry, there was an error loading this gallery item.</p>');
            popup.find('.popup-author').text('');
            popup.find('.popup-actions').empty();
        }

        getPostData(postId) {
            // Check if galleryAjax is available, if not use gallerySliderAjax
            const ajaxObj = window.galleryAjax || window.gallerySliderAjax;

            if (!ajaxObj) {
                return Promise.reject('No AJAX object available');
            }
            return $.ajax({
                url: ajaxObj.ajax_url,
                type: 'POST',
                data: {
                    action: 'get_gallery_post_data',
                    post_id: postId,
                    nonce: ajaxObj.nonce
                }
            });
        }

        populatePopup(data) {
            const popup = this.popup;

            // Reset image index
            this.currentImageIndex = 0;

            // Update image - use first image from gallery or featured image
            let imageUrl = data.featured_image;
            if (data.gallery_images && data.gallery_images.length > 0) {
                const firstImage = data.gallery_images[0];
                if (typeof firstImage === 'string') {
                    imageUrl = firstImage;
                } else if (firstImage && firstImage.url) {
                    imageUrl = firstImage.url;
                } else if (firstImage && firstImage.sizes && firstImage.sizes.large) {
                    imageUrl = firstImage.sizes.large;
                }
            }

            if (imageUrl) {
                popup.find('.popup-image').attr('src', imageUrl);
                popup.find('.popup-image').attr('alt', data.title || 'Gallery Image');
            }

            // Update content - use author instead of title
            popup.find('.popup-title').text(data.author || 'Unknown Author');
            
            // Update description content - show/hide based on content
            const contentContainer = popup.find('.popup-content-text');
            if (data.content && data.content.trim() !== '') {
                contentContainer.html(data.content).show();
            } else {
                contentContainer.empty().hide();
            }
            
            popup.find('.popup-author').text(data.author ? `By ${data.author}` : '');

            // Update post navigation buttons in footer
            const prevBtn = popup.find('.popup-post-prev');
            const nextBtn = popup.find('.popup-post-next');

            // Update main navigation arrows
            const navPrevBtn = popup.find('.popup-nav-prev');
            const navNextBtn = popup.find('.popup-nav-next');

            // For infinite navigation, never disable buttons if we have more than 1 item
            const totalOriginalItems = this.originalItems ? this.originalItems.length : 0;
            const hasMultipleItems = totalOriginalItems > 1;

            prevBtn.prop('disabled', !hasMultipleItems);
            nextBtn.prop('disabled', !hasMultipleItems);
            navPrevBtn.prop('disabled', !hasMultipleItems);
            navNextBtn.prop('disabled', !hasMultipleItems);

            // Update image navigation buttons
            const hasMultipleImages = data.gallery_images && data.gallery_images.length > 1;
            const imagePrevBtn = popup.find('.popup-image-prev');
            const imageNextBtn = popup.find('.popup-image-next');

            if (hasMultipleImages) {
                // Show/hide image navigation based on current position
                if (this.currentImageIndex === 0) {
                    imagePrevBtn.hide();
                } else {
                    imagePrevBtn.show().prop('disabled', false);
                }

                if (this.currentImageIndex === data.gallery_images.length - 1) {
                    imageNextBtn.hide();
                } else {
                    imageNextBtn.show().prop('disabled', false);
                }
            } else {
                imagePrevBtn.hide();
                imageNextBtn.hide();
            }

            // Update CTA buttons - show/hide based on content
            const actionsContainer = popup.find('.popup-actions');
            actionsContainer.empty();

            if (data.cta_text && data.cta_text.trim() !== '' && data.cta_url && data.cta_url.trim() !== '') {
                actionsContainer.append(
                    `<a href="${data.cta_url}" class="cta-btn" target="_blank">${data.cta_text}</a>`
                ).show();
            } else {
                actionsContainer.hide();
            }

            // Update image counter - ensure minimum of 1 for total images
            let totalImages = 1; // Default to 1 (featured image)
            if (data.gallery_images && data.gallery_images.length > 0) {
                totalImages = data.gallery_images.length;
            }
            
            popup.find('.current-image').text(this.currentImageIndex + 1);
            popup.find('.total-images').text(totalImages);
        }
    }

    // Initialize when document is ready
    $(document).ready(function() {
        new ImageGallerySlider();
    });

    // Add CSS for popup open state
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            body.popup-open {
                overflow: hidden;
            }
            .gallery-slider.dragging {
                cursor: grabbing;
                user-select: none;
            }
        `)
        .appendTo('head');

})(jQuery);
